import { render } from "./errorPage3.vue?vue&type=template&id=baba5bec&scoped=true"
const script = {}

import "./errorPage3.vue?vue&type=style&index=0&id=baba5bec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-baba5bec"]])

export default __exports__